// routes
import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;

export const FIREBASE_API = {
  apiKey: 'AIzaSyAv-84qMM_h8pAyXRQTp0Zua5GYOGGXBIY',
  authDomain: 'bsbhp-1feae.firebaseapp.com',
  projectId: 'bsbhp-1feae',
  storageBucket: 'bsbhp-1feae.appspot.com',
  messagingSenderId: '991108857804',
  appId: '1:991108857804:web:774ab6f67620a94afc6769',
  measurementId: 'G-4R5DR11WT9',
};

export const AMPLIFY_API = {
  userPoolId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: process.env.REACT_APP_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
};

export const SUPABASE_API = {
  url: 'https://muzvgvlubfowdbmclliu.supabase.co',
  anonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im11enZndmx1YmZvd2RibWNsbGl1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NjE1MjI5NzYsImV4cCI6MTk3NzA5ODk3Nn0.8TynOrH3agyMmbv8HWItsfRjL-qsHGsfP16hvgQowIM',
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = '/dashboard/analytics';
